export default function Card({ title, subtitle, children, span = 1 }) {
  return (
    <section className={`card span-${span}`}>
      <header className="card-head">
        <h3>{title}</h3>
        {subtitle && <span className="muted">{subtitle}</span>}
      </header>
      <div className="card-body">{children}</div>
    </section>
  );
}

export function Bar({ value, max, label, highlight }) {
  const pct = max > 0 ? (value / max) * 100 : 0;
  return (
    <div className="bar-row">
      <span className="bar-label">{label}</span>
      <div className="bar-track">
        <div
          className={"bar-fill" + (highlight ? " hi" : "")}
          style={{ width: `${pct}%` }}
        />
      </div>
      <span className="bar-value">{value}</span>
    </div>
  );
}
